const updates = [
  { time: '10分钟前', title: '《我独自升级》第198话更新', tag: '韩漫', tagColor: 'bg-primary-100 text-primary-700' },
  { time: '28分钟前', title: '《咒术回战》第262话上线', tag: '日漫', tagColor: 'bg-accent-100 text-accent-800' },
  { time: '1小时前', title: '《狐妖小红娘》番外篇更新', tag: '国漫', tagColor: 'bg-secondary-100 text-secondary-700' },
  { time: '2小时前', title: '《全知读者视角》第215话', tag: '韩漫', tagColor: 'bg-primary-100 text-primary-700' },
  { time: '3小时前', title: '《电锯人》第二部第42话', tag: '日漫', tagColor: 'bg-accent-100 text-accent-800' },
  { time: '4小时前', title: '《斗罗大陆》最终章更新', tag: '国漫', tagColor: 'bg-secondary-100 text-secondary-700' },
  { time: '6小时前', title: '《外貌至上主义》第178话', tag: '韩漫', tagColor: 'bg-primary-100 text-primary-700' },
  { time: '8小时前', title: '《间谍过家家》第105话上线', tag: '日漫', tagColor: 'bg-accent-100 text-accent-800' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-semibold rounded-full bg-accent-100 text-accent-800 mb-3 whitespace-nowrap">
            实时快讯
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            最新更新
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-md mx-auto">
            热门漫画最新章节第一时间追踪，不错过任何精彩
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updates.map((item, i) => (
            <a
              key={i}
              href="#updates"
              className="flex items-center gap-4 py-4 border-b border-background-200/70 last:border-b-0 group cursor-pointer hover:bg-background-100/50 px-3 -mx-3 rounded-md transition-colors"
            >
              <span className="text-xs text-foreground-400 whitespace-nowrap w-16 shrink-0">
                {item.time}
              </span>
              <span className={`text-xs px-2 py-0.5 rounded font-medium whitespace-nowrap shrink-0 ${item.tagColor}`}>
                {item.tag}
              </span>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors flex-1 line-clamp-1">
                {item.title}
              </span>
              <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors shrink-0"></i>
            </a>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="#updates"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看更多更新
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}